import { lazyLoad } from 'src/utils/loadable';

export const ForceChangePassword = lazyLoad(
  () => import('./index'),
  (module: { ForceChangePassword: any }): any => module.ForceChangePassword,
);
